import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const myListApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);

    return {
      getMyList: query({
        query: () => "/mylist",
        providesTags: ["MyList"],
      }),

      addToMyList: mutation({
        query: (videoId) => ({
          url: "/mylist/add",
          method: "POST",
          body: { videoId },
        }),
        invalidatesTags: ["MyList"],
      }),

      removeFromMyList: mutation({
        query: (videoId) => ({
          url: "/mylist/remove",
          method: "POST",
          body: { videoId },
        }),
        invalidatesTags: ["MyList"],
      }),

      // Clear user list
      clearMyList: builder.mutation({
        query() {
          return {
            url: "/mylist/clear",
            method: "DELETE",
          };
        },
        invalidatesTags: ["MyList"],
      }),
    };
  },
});

export const {
  useGetMyListQuery,
  useAddToMyListMutation,
  useRemoveFromMyListMutation,
  useClearMyListMutation
} = myListApiSlice;
